import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import { DropdownModel } from "../../models/dropdownModel";
import { Dropdown } from 'primereact/dropdown';
import { DosageLevelModel } from "../../models/dosage";
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { Editor } from 'primereact/editor';
import { enumToDropdownArray } from '../../common/functions/helperFunctions';
import DiseaseService from '../../services/diseaseService';
import { AgeGroup } from '../../common/enums';
import { RoaTypeDescr } from '../../common/enums';
import DiseaseListDialog from './diseaseListDialog';
import { DiseaseAdminModel } from '../../models/disease';

interface IProps {
  isVisible: boolean,
  cancelClick: any,
  okClick: any,
  currentDosageLevel: DosageLevelModel,
  selectedLangId: number
}

interface IState {
  isLoading: boolean;
  error: any;
  currentDosageLevel: DosageLevelModel;
  ageGroupDropdown: Array<DropdownModel>;
  roaTypeDropdown: Array<DropdownModel>;
  isVisibleDiseaseListDialog: boolean;
}

class DosageLevelAddEditDialog extends React.Component<IProps, IState> {
  diseaseService = new DiseaseService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      error: null,
      currentDosageLevel: this.props.currentDosageLevel,
      ageGroupDropdown: new Array<DropdownModel>(0),
      roaTypeDropdown: new Array<DropdownModel>(0),
      isVisibleDiseaseListDialog: false
    }
  }

  componentDidMount() {
    this.initData();
  }

  initData() {
    const ageGroupDropdown: Array<DropdownModel> = [{ label: 'Select', value: -1 }];
    const roaTypeDropdown: Array<DropdownModel> = [{ label: 'Select', value: -1 }];

    this.setState({
      ageGroupDropdown: ageGroupDropdown.concat(enumToDropdownArray(AgeGroup)),
      roaTypeDropdown: roaTypeDropdown.concat(enumToDropdownArray(RoaTypeDescr))
    });
  }

  handleOkButton = event => {
    event.preventDefault();
    this.props.okClick(this.state.currentDosageLevel);
  }

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  handleDiseaseAddEditClick() {
    this.setState({
      isVisibleDiseaseListDialog: true
    });
  }

  handleDosageLevelChange = (key, value) => {
    const currentDosageLevel: DosageLevelModel = { ...this.state.currentDosageLevel };
    currentDosageLevel[key] = value;
    this.setState({ currentDosageLevel: { ...currentDosageLevel } });
  };

  handleDiseaseAddButton = (currentDisease: DiseaseAdminModel) => {
    let currentDosageLevel = this.state.currentDosageLevel;
    currentDosageLevel.disease = currentDisease;
    this.setState({
      currentDosageLevel: currentDosageLevel,
      isVisibleDiseaseListDialog: false
    });
  }

  handleDiseaseRemoveClick() {
    let currentDosageLevel = this.state.currentDosageLevel;
    currentDosageLevel.disease = new DiseaseAdminModel;

    this.setState({
      currentDosageLevel: currentDosageLevel
    });
  }

  handleDiseaseCancelButton = () => {
    this.setState({
      isVisibleDiseaseListDialog: false
    });
  };

  handleContentChange = (key, value) => {
    const level: DosageLevelModel = { ...this.state.currentDosageLevel };
    let content = level.dosageLevelContent.find(r => r.langId == this.props.selectedLangId);
    if (content) {
      content[key] = value;
    }
    this.setState({ currentDosageLevel: { ...level } });
  };

  getValueContent = (key) => {
    let content = this.state.currentDosageLevel.dosageLevelContent.find(r => r.langId == this.props.selectedLangId)
    if (content && content[key]) {
      return content[key];
    }
    return '';
  }

  render() {
    let { ageGroupDropdown, roaTypeDropdown, currentDosageLevel } = this.state;
    let { disease } = currentDosageLevel;

    let diseaseValue: string = "Select";
    if (disease && disease.diseaseCode) {
      diseaseValue = [disease.diseaseCode, disease.diseaseContent.map(r => r.diseaseName).filter(Boolean).join(' / ')].filter(Boolean).join(' / ');
    }

    return (
      <>
        <Dialog header="Dosage level" responsive={true} width="70%"
          modal={true}
          visible={this.props.isVisible}
          onHide={this.handleCancelButton}
          footer={
            <div>
              <Button label="Add" icon="pi pi-check" onClick={this.handleOkButton} className="p-button-raised" disabled={!currentDosageLevel ||
                !currentDosageLevel.disease || !currentDosageLevel.disease.diseaseId || !currentDosageLevel.ageGroupId
                || currentDosageLevel.ageGroupId <= 0 || !currentDosageLevel.roaTypeId || currentDosageLevel.roaTypeId <= 0} />
              <Button label="Cancel" icon="pi pi-times" onClick={this.handleCancelButton} className="p-button-secondary p-button-raised" />
            </div>
          }>
          <div style={{ minHeight: '500px', maxHeight: '650px' }}>
            <div className="p-fluid p-grid">
              <div className="p-col-12 p-md-3">
                <label>Age group:</label>
                <Dropdown
                  style={{ width: '100%' }}
                  options={ageGroupDropdown}
                  value={(currentDosageLevel && currentDosageLevel.ageGroupId != null) ? currentDosageLevel.ageGroupId : -1}
                  onChange={(e) => this.handleDosageLevelChange('ageGroupId', e.value)}
                />
              </div>
              <div className="p-col-12 p-md-3">
                <label>Road of administration:</label>
                <Dropdown
                  style={{ width: '100%' }}
                  options={roaTypeDropdown}
                  value={(currentDosageLevel && currentDosageLevel.roaTypeId != null) ? currentDosageLevel.roaTypeId : -1}
                  onChange={(e) => this.handleDosageLevelChange('roaTypeId', e.value)}
                />
              </div>
              <div className="p-col-12 p-md-6">
                <label style={{ marginLeft: '9px', marginTop: '9px' }}>Disease:</label>
                <div className="p-inputgroup" style={{ marginLeft: '9px', marginRight: '9px' }}>
                  <InputText
                    readOnly={true}
                    onClick={() => this.handleDiseaseAddEditClick()}
                    value={diseaseValue}
                  />
                  <Button
                    icon="pi pi-plus"
                    className="p-button-success"
                    onClick={() => this.handleDiseaseAddEditClick()}
                  />
                  <Button
                    icon="pi pi-times-circle"
                    className="p-button-warning"
                    onClick={() => this.handleDiseaseRemoveClick()}
                  />
                </div>
              </div>
              <div className="p-col-12 p-md-3">
                <label>Single dose:</label>
                <InputText
                  name="singleDose"
                  value={currentDosageLevel && currentDosageLevel.singleDose ? currentDosageLevel.singleDose : ""}
                  onChange={(e) => this.handleDosageLevelChange('singleDose', e.target['value'])}
                />
              </div>
              <div className="p-col-12 p-md-3">
                <label>Loading dose:</label>
                <InputText
                  name="loadingDose"
                  value={currentDosageLevel && currentDosageLevel.loadingDose ? currentDosageLevel.loadingDose : ""}
                  onChange={(e) => this.handleDosageLevelChange('loadingDose', e.target['value'])}
                />
              </div>
              <div className="p-col-12 p-md-3">
                <label>Max daily dose:</label>
                <InputText
                  name="maxDailyDose"
                  value={currentDosageLevel && currentDosageLevel.maxDailyDose ? currentDosageLevel.maxDailyDose : ""}
                  onChange={(e) => this.handleDosageLevelChange('maxDailyDose', e.target['value'])}
                />
              </div>
              <div className="p-col-12 p-md-3">
                <label>Frequency of intake:</label>
                <InputText
                  name="frequencyOfIntake"
                  value={currentDosageLevel && currentDosageLevel.frequencyOfIntake ? currentDosageLevel.frequencyOfIntake : ""}
                  onChange={(e) => this.handleDosageLevelChange('frequencyOfIntake', e.target['value'])}
                />
              </div>
              <div className="p-col-12 p-md-3">
                <label>Intakes interval:</label>
                <InputText
                  name="minMaxTimeBetweenIntakes"
                  value={currentDosageLevel && currentDosageLevel.minMaxTimeBetweenIntakes ? currentDosageLevel.minMaxTimeBetweenIntakes : ""}
                  onChange={(e) => this.handleDosageLevelChange('minMaxTimeBetweenIntakes', e.target['value'])}
                />
              </div>
              <div className="p-col-12 p-md-3">
                <label>Titration interval:</label>
                <InputText
                  name="minMaxTitration"
                  value={currentDosageLevel && currentDosageLevel.minMaxTitration ? currentDosageLevel.minMaxTitration : ""}
                  onChange={(e) => this.handleDosageLevelChange('minMaxTitration', e.target['value'])}
                />
              </div>
              <div className="p-col-12 p-md-3">
                <label>Age range:</label>
                <InputText
                  name="ageRange"
                  value={currentDosageLevel && currentDosageLevel.ageRange ? currentDosageLevel.ageRange : ""}
                  onChange={(e) => this.handleDosageLevelChange('ageRange', e.target['value'])}
                />
              </div>
              <div className="p-col-12 p-md-3">
                <label>Weigh range:</label>
                <InputText
                  name="weightRange"
                  value={currentDosageLevel && currentDosageLevel.weightRange ? currentDosageLevel.weightRange : ""}
                  onChange={(e) => this.handleDosageLevelChange('weightRange', e.target['value'])}
                />
              </div>
              <div className="p-col-12 p-md-6">
                <label>Comments:</label>
                <InputTextarea
                  name="comments"
                  rows={2}
                  value={this.getValueContent('comments')}
                  style={{ width: '100%' }}
                  onChange={(e) => this.handleContentChange('comments', e.target['value'])}
                />
              </div>
              <div className="p-col-12 p-md-6">
                <label>Uses:</label>
                <InputTextarea
                  name="uses"
                  rows={2}
                  value={this.getValueContent('uses')}
                  style={{ width: '100%' }}
                  onChange={(e) => this.handleContentChange('uses', e.target['value'])}
                />
              </div>
              <div className="p-col-12 p-md-12">
                <label>Specific description:</label>
                <Editor
                  style={{ width: '100%', height: '120px' }}
                  value={this.getValueContent('specificDescription')}
                  onTextChange={(e) => { this.handleContentChange('specificDescription', e.htmlValue) }}
                />
              </div>
            </div>
          </div>
        </Dialog >

        {this.state.isVisibleDiseaseListDialog ? (
          <DiseaseListDialog
            selectedDisease={disease}
            addClick={this.handleDiseaseAddButton}
            cancelClick={this.handleDiseaseCancelButton}
            isVisible={this.state.isVisibleDiseaseListDialog}
          />
        ) : null}
      </>
    )
  }
}

export default DosageLevelAddEditDialog;